/** Shared Google OAuth helpers for popup + redirect fallback. */

export const GOOGLE_CALLBACK_PATH = '/auth/google/callback';
export const GOOGLE_OAUTH_STATE_KEY = 'sc_google_oauth_state';

export function getGoogleRedirectUri() {
  if (typeof window === 'undefined') return '';
  return `${window.location.origin}${GOOGLE_CALLBACK_PATH}`;
}

export function createOAuthState() {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
}

export function loadGisScript() {
  if (window.google?.accounts?.id && window.google?.accounts?.oauth2) {
    return Promise.resolve();
  }
  const existing = document.querySelector('script[data-gsi-client="true"]');
  if (existing) {
    return new Promise((resolve, reject) => {
      if (window.google?.accounts?.id && window.google?.accounts?.oauth2) {
        resolve();
        return;
      }
      existing.addEventListener('load', () => resolve(), { once: true });
      existing.addEventListener('error', () => reject(new Error('load failed')), {
        once: true,
      });
    });
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    script.dataset.gsiClient = 'true';
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('load failed'));
    document.body.appendChild(script);
  });
}

/** Start a full-page Google OAuth redirect (popup-blocker fallback). */
export function startGoogleRedirectLogin(clientId) {
  if (!window.google?.accounts?.oauth2) {
    throw new Error('Google Sign-In unavailable');
  }
  const state = createOAuthState();
  sessionStorage.setItem(GOOGLE_OAUTH_STATE_KEY, state);

  const redirectClient = window.google.accounts.oauth2.initCodeClient({
    client_id: clientId,
    scope: 'openid email profile',
    ux_mode: 'redirect',
    redirect_uri: getGoogleRedirectUri(),
    state,
  });
  redirectClient.requestCode();
}
